import { useEffect, useState } from 'react';
import { getMyCoupons, getUserInfo } from '../../apis/user';
import { Button } from '../../components/Button';
import { DirectoryBar } from '../../components/DirectoryBar';
import { H6 } from '../../components/H6';
import { Section } from '../../components/Section';
import { UserInfo, ViewUserCoupon } from '../../types/types';
import { MyCouponTable } from './MyCouponTable';
import { MyPointTable } from './MyPointTable';
import qs from "qs";
import {useHistory} from "react-router-dom";

const tabs = [{ name: '적립금' }, { name: '쿠폰' }];

export const MyPagePoint = () => {
  const { location } = useHistory();
  const [tab, setTab] = useState(tabs[0]);
  const [info, setInfo] = useState<UserInfo>();
  const [coupons, setCoupons] = useState<ViewUserCoupon[]>([]);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    getUserInfo().then(r => setInfo(r.data.payload)).catch(e => console.log(e));
    getMyCoupons().then(r => setCoupons(r.data.payload)).catch(e => console.log(e));
    setTab(query.couponTab ? tabs[1] : tabs[0])
  }, []);

  if (!info) return null;
  return (
    <div className="mb-10 md:text-13">
      <DirectoryBar text="적립금 & 쿠폰" backArrow className="md:hidden" />
      <H6 className="border-b border-gray-200 pb-2 mb-6 font-semibold">
        적립금 {'&'} 쿠폰
      </H6>

      <Section className="md:flex">
        <div className={`grid grid-cols-2 items-center`}>
          <p className="text-13 text-gray-500 pr-2">현재 보유 적립금</p>
          <p className="font-semibold">{info.ownPoint.toLocaleString()}p</p>
        </div>

        <div className={`grid grid-cols-2 items-center`}>
          <p className="text-13 text-gray-500 pr-2">보유 쿠폰</p>
          <p className="font-semibold">{coupons.length}개</p>
        </div>
      </Section>

      <Section className="space-x-4 py-5">
        {tabs.map(t => (
          <Button
            key={t.name}
            text={t.name}
            className={`text-sm font-bold  ${t.name === tab.name ? 'filled-brand-1' : 'bg-brand-2'
              } `}
            onClick={() => setTab(t)}
          />
        ))}
      </Section>

      {tab.name === tabs[0].name && <MyPointTable />}
      {tab.name === tabs[1].name && <MyCouponTable />}
    </div>
  );
};
